"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRoleAtLeast = exports.getRoleHierarchy = exports.hasAllPermissions = exports.hasAnyPermission = exports.hasPermission = exports.ROLE_PERMISSIONS = void 0;
const permission_enum_1 = require("../enums/permission.enum");
const userCompanyRole_enum_1 = require("../enums/userCompanyRole.enum");
const COMMON_PERMISSIONS = [
    permission_enum_1.Permission.VIEW_DIFFUSING_DOCUMENT,
    permission_enum_1.Permission.VIEW_PERSONAL_INFO,
    permission_enum_1.Permission.EDIT_PERSONAL_INFO,
    permission_enum_1.Permission.VIEW_PREFERENCES,
    permission_enum_1.Permission.EDIT_PREFERENCES,
    permission_enum_1.Permission.VIEW_LEGAL_INFO,
    permission_enum_1.Permission.VIEW_PROFILE_TASKS,
    permission_enum_1.Permission.VIEW_PROFILE_DOCUMENTS,
    permission_enum_1.Permission.VIEW_DASHBOARD,
    permission_enum_1.Permission.VIEW_MY_DOCUMENTS,
    permission_enum_1.Permission.VIEW_MY_TASKS,
];
const VALIDATOR_PERMISSIONS = [
    ...COMMON_PERMISSIONS,
    permission_enum_1.Permission.INVITE_USER_TO_GROUP,
    permission_enum_1.Permission.ASSIGN_TASK,
    permission_enum_1.Permission.CANCEL_TASK,
    permission_enum_1.Permission.VIEW_OLD_DOCUMENT_VERSION,
    permission_enum_1.Permission.VALIDATE_DOCUMENT,
    permission_enum_1.Permission.DIFFUSE_DOCUMENT,
];
const ADMIN_PERMISSIONS = [
    ...VALIDATOR_PERMISSIONS,
    permission_enum_1.Permission.SEND_FOR_VALIDATION,
    permission_enum_1.Permission.UPLOAD_NEW_VERSION,
    permission_enum_1.Permission.ARCHIVE_DOCUMENT,
    permission_enum_1.Permission.CREATE_GROUP,
    permission_enum_1.Permission.RENAME_GROUP,
    permission_enum_1.Permission.DELETE_GROUP,
    permission_enum_1.Permission.CREATE_STATUS,
    permission_enum_1.Permission.RENAME_STATUS,
    permission_enum_1.Permission.DELETE_STATUS,
    permission_enum_1.Permission.REMOVE_USER_FROM_GROUP,
    permission_enum_1.Permission.EDIT_USER_INFO,
    permission_enum_1.Permission.EDIT_USER_PERMISSIONS,
    permission_enum_1.Permission.CREATE_THEME,
    permission_enum_1.Permission.RENAME_THEME,
    permission_enum_1.Permission.DELETE_THEME,
    permission_enum_1.Permission.CREATE_FOLDER,
    permission_enum_1.Permission.RENAME_FOLDER,
    permission_enum_1.Permission.DELETE_FOLDER,
    permission_enum_1.Permission.ADD_DOCUMENT,
    permission_enum_1.Permission.RENAME_DOCUMENT,
    permission_enum_1.Permission.DELETE_DOCUMENT,
    permission_enum_1.Permission.VIEW_COMPANY_INFO,
    permission_enum_1.Permission.EDIT_COMPANY_INFO,
    permission_enum_1.Permission.VIEW_SUBSCRIPTION,
    permission_enum_1.Permission.EDIT_SUBSCRIPTION,
    permission_enum_1.Permission.VIEW_PERFORMANCE_DASHBOARD,
    permission_enum_1.Permission.VIEW_ADMIN_BANNER,
    permission_enum_1.Permission.SWITCH_COMPANY,
    permission_enum_1.Permission.ADD_COMPANY,
    permission_enum_1.Permission.DELETE_COMPANY,
    permission_enum_1.Permission.VIEW_MY_COMPANIES,
    permission_enum_1.Permission.VIEW_USER_MANAGEMENT,
];
const SUPER_ADMIN_PERMISSIONS = [
    ...ADMIN_PERMISSIONS,
    permission_enum_1.Permission.ADD_SUPER_USER,
    permission_enum_1.Permission.DELETE_SUPER_USER,
    permission_enum_1.Permission.TRANSFER_SUPER_ADMIN_RIGHTS,
];
exports.ROLE_PERMISSIONS = {
    [userCompanyRole_enum_1.UserCompanyRole.SUPER_ADMIN]: SUPER_ADMIN_PERMISSIONS,
    [userCompanyRole_enum_1.UserCompanyRole.SUPER_USER]: ADMIN_PERMISSIONS,
    [userCompanyRole_enum_1.UserCompanyRole.VALIDATOR]: VALIDATOR_PERMISSIONS,
    [userCompanyRole_enum_1.UserCompanyRole.USER]: COMMON_PERMISSIONS,
};
const hasPermission = (role, permission) => {
    return exports.ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
};
exports.hasPermission = hasPermission;
const hasAnyPermission = (role, permissions) => {
    return permissions.some((permission) => (0, exports.hasPermission)(role, permission));
};
exports.hasAnyPermission = hasAnyPermission;
const hasAllPermissions = (role, permissions) => {
    return permissions.every((permission) => (0, exports.hasPermission)(role, permission));
};
exports.hasAllPermissions = hasAllPermissions;
const getRoleHierarchy = () => [
    userCompanyRole_enum_1.UserCompanyRole.SUPER_ADMIN,
    userCompanyRole_enum_1.UserCompanyRole.SUPER_USER,
    userCompanyRole_enum_1.UserCompanyRole.VALIDATOR,
    userCompanyRole_enum_1.UserCompanyRole.USER,
];
exports.getRoleHierarchy = getRoleHierarchy;
const isRoleAtLeast = (currentRole, requiredRole) => {
    const hierarchy = (0, exports.getRoleHierarchy)();
    const currentIndex = hierarchy.indexOf(currentRole);
    const requiredIndex = hierarchy.indexOf(requiredRole);
    return currentIndex !== -1 && requiredIndex !== -1 && currentIndex <= requiredIndex;
};
exports.isRoleAtLeast = isRoleAtLeast;
//# sourceMappingURL=rolePermissions.constant.js.map